<template>
  <div class="patient-card-component">
    <div class="patient-card">
      <b-row
        class="m-0"
      >
        <b-col class="pl-0 pr-0">
          <div
            v-if="internalPatient"
            class="entity-card"
          >
            <b-row class="py-2 px-3">
              <b-col
                class="d-flex align-items-center"
                md="12"
                lg="3"
              >
                <b-button
                  class="btn__icon btn__icon--primary"
                  @click="$emit('openPatientModal')"
                >
                  <i
                    class="far fa-user-circle mr-2 main"
                    aria-hidden="true"
                  />
                </b-button>
                <span
                  class="entity-card__title d-flex align-items-center font-weight--medium truncated"
                  qa="patient-card-fullname"
                >
                  {{ fullName }}
                </span>
              </b-col>
              <b-col
                cols="12"
                class="px-0 py-2 d-none d-sm-block d-lg-none"
              >
                <div class="horizontal-divider" />
              </b-col>
              <b-col
                v-if="globalParameters.mainPatientIdentifierType"
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ globalParameters.mainPatientIdentifierType.name }}</span>
                <span
                  class="entity-card__data--text"
                  qa="patient-card-main-identifier"
                >{{ internalPatient.mainPatientIdentifier ? internalPatient.mainPatientIdentifier.paiIdentifier : '-' }}</span>
              </b-col>
              <b-col
                v-if="globalParameters.secondaryPatientIdentifierType"
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ globalParameters.secondaryPatientIdentifierType.name }}</span>
                <span
                  class="entity-card__data--text"
                  qa="patient-card-secondary-identifier"
                >{{ internalPatient.secondaryPatientIdentifier ? internalPatient.secondaryPatientIdentifier.paiIdentifier : '-' }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('entities.patient.gender') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="patient-card-gender"
                >{{ genderName }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('entities.patient.birthdate') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="patient-card-birthdate"
                >{{ internalPatient.patBirthdate | date }}</span>
              </b-col>
              <b-col
                class="entity-card__data"
              >
                <span class="entity-card__data--label">{{ $t('global.age') }}</span>
                <span
                  class="entity-card__data--text"
                  qa="patient-card-birthday"
                >{{ patientTimeOld(internalPatient.patBirthdate) }}</span>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { PATIENT_IDENTIFIER_CODES } from '@/api/resources/IdentifierRegexesService'
import { cloneDeep } from 'lodash'

export default {
    name: 'PatientCard',
    props: {
        patient: { type: Object, required: true }
    },
    data() {
        return {
            PATIENT_IDENTIFIER_CODES: PATIENT_IDENTIFIER_CODES,
            internalPatient: null
        }
    },
    computed: {
        genderName() {
            return this.internalPatient.genderName ?? this.internalPatient.gender?.name
        },
        fullName() {
            const { patName, patMiddleName, patSurname1, patSurname2 } = this.internalPatient
            return [patName, patMiddleName, patSurname1, patSurname2].filter(Boolean).join(' ')
        },
        routeIsClinical() {
            return this.$route.path.startsWith('/requests/')
        }
    },
    watch: {
        patient() {
            this.internalPatient = cloneDeep(this.patient)
        }
    },
    mounted() {
        this.internalPatient = cloneDeep(this.patient)
        this.$eventHub.$on('updatePatientInformation', this.onUpdatePatient)
    },
    beforeDestroy() {
        this.$eventHub.$off('updatePatientInformation', this.onUpdatePatient)
    },
    methods: {
        onUpdatePatient(updatedPatient) {
            if (updatedPatient.patId === this.internalPatient.patId) {
                this.internalPatient = cloneDeep(updatedPatient)
            }
        },
        patientTimeOld(patBirthday) {
            return this.getPatientTimeOld(patBirthday)
        }
    }
}

</script>

<style lang="scss">

.patient-card-component .btn__icon .btn__icon--primary i {
    font-size: font-size(normal) !important;
}

.patient-card-component .patient-card .truncated {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>
